<script>
import appConfig from "@/app.config";
import Swal from "sweetalert2";
//import Basic from "./basic";
import axios from "axios";

import {
  required,
  //email,
  //minLength,
  //sameAs,
  //maxLength,
  //minValue,
  //maxValue,
  //numeric,
  //url,
  //alphaNum
} from "vuelidate/lib/validators";

/**
 * Form validation component
 */
export default {
  page: {
    title: "Customer Location",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {  },
  props:{
    idRecord: Number,
    idEntity: [String,null],
    record:   [Object, null]
  },
  data() {
    return {
      info: null,
      componentKey: 0,
      submitted: false,
      title: "Customer location registration",
      items: [
        {text: "Management",  href: "/"},
        {text: "Customers",   href: "/management/customers"},
        {text: "Location",    active: true}
      ],
      states: [
        "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii",
        "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts",
        "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico",
        "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota",
        "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming", "Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador", "Nova Scotia", "Ontario", "Prince Edward Island", "Quebec", "Saskatchewan"
      ],
      form: {
        id_customer:        "",
        id_state:           "",
        nm_state:           "",
        nm_city:            "",
        num_zipCode:        "",
        num_licenseNumber:  "",
        de_address:         "",
      },
    };
  },
  validations: {
    form: {
      id_customer:          { required },
      id_state:             { required },
      nm_state:             { required },
      nm_city:              { required },
      num_zipCode:          { required },
      num_licenseNumber:    { required },
      de_address:           { required },
    }
  },
  watch:{
    
  },
  created(){
    if( this.idRecord ){
      this.form.id_state            = this.record.id_state;
      this.form.nm_state            = this.record.nm_state;
      this.form.nm_city             = this.record.nm_city;
      this.form.num_zipCode         = this.record.num_zipCode;
      this.form.num_licenseNumber   = this.record.num_licenseNumber;
      this.form.de_address          = this.record.de_address;
      this.form.id_customerLocation = this.record.id_customerLocation;
    }
  },
  mounted() {

  },
  methods: {
    logState(evt){
      let id_state = 0;

      for (var i = 0; i < this.states.length; i++) {
        if( evt.target.value == this.states[i]){
          id_state = i+1;
          this.form.id_state = id_state;
        }
      }
    },

    getCustomerByID(idRecord){
      let app = this;

      axios
      .get(
        window.serverPath+'dist/mvw/controllers/customers.php',
        {
          params: {
            request:  'getCustomerByID',
            id:       idRecord
          }
        }
      )
      .then(response => {
        Swal.close();
        if( response.statusText == "OK" ){
          if(response.data){
            app.form.id_industry               = response.data.id_industry;
            app.form.nm_customer               = response.data.nm_customer;

            if(response.data.url_logo != ''){
              app.url_logo                  = 'http://gocomply.unaux.com/dist'+response.data.url_logo;
            }
          }else{
            Swal('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        }else{
          Swal('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
        }
      })
      .catch(function (error) {
        app.isLoading = false;
        if(
          error.code == "ERR_BAD_RESPONSE"    ||
          error.code == "ERR_NETWORK"
        ){
          Swal('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
        }
      });
    },

    emit(){
      Swal.close();
      this.$emit('success');
    },


    // eslint-disable-next-line no-unused-vars
    saveCustomerLocation(e) {
      let app = this;
      let successMessage = "";

      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      if( this.idRecord ){
        this.form.id_customerLocation = this.idRecord;
      }

      if( this.idEntity ){
        this.form.id_customer = this.idEntity;
      }

      if( !this.$v.form.$error ){

        Swal.fire({
          title: "Saving customer location.",
          showConfirmButton:false,
          onBeforeOpen: () => {
            Swal.showLoading();
          }
        });

        axios.post(window.serverPath+'dist/mvw/controllers/customers.php', {
          request: 'saveCustomerLocation',
          data: app.form, 
        })
        .then(function (response) {
          let action = "";

          if(response.status == 500){ app.$router.push({ name: 'Error-500' }); }
          if(response.status == 404){ app.$router.push({ name: 'Error-404' }); }
          if(response.status == 401){ app.$router.push({ name: 'Error-401' }); }
          
          if( response.data === "OK" ){
            action = "saved";
          }
          if( response.data === "UPDATED" ){
            action = "updated";
          }

          Swal.fire("Good job!", "The customer location is correctly "+action+"!", "success");
          //app.$router.push({ name: 'industries' });



          if(response.data){
            Swal.fire(
              'Congrats!!!','<p><b>'+successMessage+'</b></p>',
              'success',
            ).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                //app.$router.push({ name: 'industries'});
                app.emit();
              }
            });
          }else{
            Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        })
        .catch(function (error) {
          Swal.fire("Ooops!" + error.message, "Seems like some error ocurr, please try again.", "error");
        });
      }
    }
  }
};
</script>

<template>



    <form class="needs-validation" @submit.prevent="saveCustomerLocation">
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-md-12">
                      <h4 class="card-title">{{title}}</h4>
                      <p class="card-title-desc">Provide all information related to your customer.</p>

                      <div class="form-group">
                        <label for="id_state">State</label>
                        <select
                          class="form-control-sm"
                          :class="{ 'is-invalid': submitted && $v.form.id_state.$error }"
                          name="id_state"
                          id="id_state"
                          v-model="form.nm_state"
                          @change="logState"
                        >
                          <option value="">SELECT CUSTOMER STATE</option>
                          <option v-for="(state, index) in states" :key="index" :value="state">{{state}}</option>
                        </select>
                        <div v-if="submitted && $v.form.id_state.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_state.required">State field is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="nm_city">City name</label>
                        <input
                          type="text"
                          class="form-control-sm"
                          :class="{ 'is-invalid': submitted && $v.form.nm_city.$error }"
                          name="nm_city"
                          id="nm_city"
                          v-model="form.nm_city"
                          value=""
                        >
                        <div v-if="submitted && $v.form.nm_city.$error" class="invalid-feedback">
                          <span v-if="!$v.form.nm_city.required">City name is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="num_zipCode">Zip Code</label>
                        <input
                          type="text"
                          class="form-control-sm"
                          :class="{ 'is-invalid': submitted && $v.form.num_zipCode.$error }"
                          name="num_zipCode"
                          id="num_zipCode"
                          v-model="form.num_zipCode"
                          value=""
                        >
                        <div v-if="submitted && $v.form.num_zipCode.$error" class="invalid-feedback">
                          <span v-if="!$v.form.num_zipCode.required">Zip code is required.</span>
                          <!--<span v-if="!$v.form.num_zipCode.numeric">Zip code is only numeric digits.</span>
                          <span v-if="!$v.form.num_zipCode.maxLength">Zip code maximum length is 5 digits.</span>-->
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="num_licenseNumber">License number</label>
                        <input
                          type="text"
                          class="form-control-sm"
                          :class="{ 'is-invalid': submitted && $v.form.num_licenseNumber.$error }"
                          name="num_licenseNumber"
                          id="num_licenseNumber"
                          v-model="form.num_licenseNumber"
                          value=""
                        >
                        <div v-if="submitted && $v.form.num_licenseNumber.$error" class="invalid-feedback">
                          <span v-if="!$v.form.num_licenseNumber.required">License number code is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="de_address">Address</label>
                        <input
                          type="text"
                          class="form-control-sm"
                          :class="{ 'is-invalid': submitted && $v.form.de_address.$error }"
                          name="de_address"
                          id="de_address"
                          v-model="form.de_address"
                          value=""
                        >
                        <div v-if="submitted && $v.form.de_address.$error" class="invalid-feedback">
                          <span v-if="!$v.form.de_address.required">License number code is required.</span>
                        </div>
                      </div>

                    </div>
                  </div>


                  <div class="row">
                    <div class="col-lg-12 mt-5">
                      <div class="form-group text-center">
                        <button class="btn btn-success mr-3" type="submit">SAVE LOCATION</button>
                        <button class="btn btn-danger" @click="emit();" type="reset">CANCEL </button>
                        <!--
                        <router-link to="/management/products" class="ml-3">
                          <button class="btn btn-danger" type="reset">CANCEL </button>
                        </router-link>
                        -->
                      </div>
                    </div>
                  </div>
                </div>

                
              </div>

              <!--
              <div class="row">
                <div class="col-lg-12 mt-5 pt-5">
                  <div class="form-group text-center">
                    <button class="btn btn-success" type="submit">SAVE PRODUCT</button>
                    <router-link to="/management/products" class="ml-3">
                      <button class="btn btn-danger" type="reset">CANCEL </button>
                    </router-link>
                  </div>
                </div>
              </div>
              -->
            </form>

  
</template>
<style type="text/css">
  .form-control-sm{
    display: block;
    width: 100%;
    height: calc(1.5em + 0.5rem + 2px);
    padding: 0.25rem 0.5rem;
    font-size: 0.7875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #505d69;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.2rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
</style>